module.exports = __webpack_public_path__ + "static/demonstration-min-93d1788b322d306206ee26ee8373507b.jpg";